
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.333 8A6.67 6.67 0 018 1.333 6.67 6.67 0 0114.666 8 6.67 6.67 0 018 14.667 6.67 6.67 0 011.333 8zm2.467.467l2.393 2.393c.26.26.687.26.94 0l5.06-5.06a.664.664 0 10-.94-.94L6.666 9.447 4.74 7.527a.664.664 0 10-.94.94z","fill":"#C4CCDB"}})])
          )
        }
      }
    